import { defineStore } from "pinia";
import { ref } from "vue";

export const useModulesStore = defineStore("modulesLib", () => {
	const is_notification_lib = ref(false);
	const notificationData_lib = ref<{ textNotification: string; buttonAccept?: any }>({ textNotification: "" });

	const showNotification = (message: string) => {
		is_notification_lib.value = true;
		notificationData_lib.value.textNotification = message;
	};

	return {
		is_notification_lib,
		notificationData_lib,
		showNotification,
	};
});
